import {
  Paragraph,
  TextRun,
  HeadingLevel,
  ShadingType,
  Tab,
  TabStopType,
} from "docx"
import { createDurationString } from "../../utils/utils"

export const createHeader = text => {
  const shadingPadding = new Paragraph({
    shading: {
      type: ShadingType.CLEAR,
      fill: "F2F2F2",
    },
    children: [new TextRun({ text: "\u00A0", size: 5 })],
  })
  return [
    createSpacingLine,
    shadingPadding,
    new Paragraph({
      heading: HeadingLevel.HEADING_1,
      shading: {
        type: ShadingType.CLEAR,
        fill: "F2F2F2",
      },
      children: [
        new TextRun({
          text: " " + text,
          size: 24,
          color: "000000",
        }),
      ],
    }),
    shadingPadding,
  ]
}

export const createSubHeader = (
  role,
  organization,
  location,
  startDate,
  endDate,
) => {
  const duration = createDurationString(startDate, endDate)
  const secondLine = `${organization}${organization && location && " | "}${location}`

  return [
    createAlignedTexts(role, duration),
    new Paragraph({
      children: [
        new TextRun({
          text: secondLine,
          size: 22,
        }),
      ],
    }),
  ]
}

export const createBulletPoint = text => {
  if (!text.trim()) return null

  return new Paragraph({
    text: text,
    bullet: {
      level: 0,
    },
    size: 20,
  })
}

export const createSpacingLine = new Paragraph({
  children: [
    new TextRun({
      text: "",
      size: 10,
    }),
  ],
})

export const createAlignedTexts = (leftText, rightText) => {
  return new Paragraph({
    spacing: {
      before: 50,
    },
    tabStops: [
      {
        position: 10450,
        type: TabStopType.RIGHT,
      },
    ],
    children: [
      new TextRun({
        text: leftText,
        bold: true,
        size: 22,
      }),
      new TextRun({
        children: [
          new Tab(),
          rightText,
        ],
        size: 22,
      }),
    ],
  })
}

export const createSkillsInterestsBullet = (text) => {
  if (!text.trim()) return null

  return new Paragraph({
    children: [
      new TextRun({
        text: text,
        size: 20,
      })
    ]
  })
}
